const localization = {
  en: {
    testResults: 'Test Results',
    medications: 'Medications',
    allergies: 'Allergies',
    immunizations: 'Immunizations',
    healthConditions: 'Health Conditions',
    radiology: 'Radiology',
    documents: 'Documents',
    microbiology: 'Microbiology',
    unavailableMessage: "Information may be unavailable due to patient's age. ",
    learnMore: 'Learn more',
    noDataAvailable: 'No Data Available',
    noteText:
      'The information provided below is in the electronic medical record. If you believe any data is incorrect, please notify the office. ',
    noteTextBold: 'Please Note: Not all medical record data will be viewable.',
    print: 'Print',
    patientName: 'Patient Name: ',
    dob: 'DOB: ',
    disclaimer: ''
  },
  es: {
    testResults: 'Resultados de la prueba',
    medications: 'Medicamentos',
    allergies: 'Alergias',
    immunizations: 'Inmunizaciones',
    healthConditions: 'Afecciones médicas',
    radiology: 'Radiología',
    documents: 'Documentos',
    microbiology: 'Microbiología',
    unavailableMessage:
      'La información puede no estar disponible debido a la edad del paciente. ',
    learnMore: 'Obtenga más información',
    noDataAvailable: 'No hay datos disponibles',
    noteText:
      'La información que se proporciona a continuación se encuentra en la historia clínica electrónica. Si usted Si cree que algún dato es incorrecto, notifíquelo a la oficina. ',
    noteTextBold:
      ' Tenga en cuenta: No todos Los datos de la historia clínica serán visibles.',
    print: 'Print es',
    patientName: 'Patient Name: es',
    dob: 'Fecha de nacimiento: ',
    disclaimer: ''
  },
  /* eslint-disable no-secrets/no-secrets */
  keyMapping: {
    testResults: 'UFD_Test_Results_Text',
    medications: 'UFD_Medications_Text',
    allergies: 'UFD_Allergies_Text',
    immunizations: 'UFD_Immunizations_Text',
    healthConditions: 'UFD_Health_Conditions_Text',
    radiology: 'UFD_Radiology_Text',
    documents: 'UFD_Documents_Text',
    microbiology: 'UFD_Microbiology_Text',
    unavailableMessage: 'UFD_Adolescent_Proxy_Disclaimer',
    learnMore: 'UFD_Disclaimer_Learn_More',
    noDataAvailable: 'UFD_No_Data_Text',
    noteText: 'UFD_My_Health_Disclaimer_Text',
    noteTextBold: 'UFD_My_Health_Disclaimer_Note',
    print: '',
    patientName: '',
    dob: '',
    disclaimer: ''
  }
  /* eslint-enable no-secrets/no-secrets */
}

export default localization
